import { shellRoomsAPI } from "@/views/ShellRooms/api";

export const getShellRooms = async () => {
  try {
    const res = await shellRoomsAPI.getShellRooms();
    return res?.data;
  } catch (e) {}
};

export const getRoomPurposesFS = async () => {
  try {
    const res = await shellRoomsAPI.getRoomPurposesFS();
    return res?.data;
  } catch (e) {}
};
export const updRoomPurpose = async (body) => {
  try {
    const res = await shellRoomsAPI.updRoomPurpose(body);
    return res?.data;
  } catch (e) {}
};
export const updCountCeiling = async (body) => {
  try {
    console.log("body", body);
    return;

    // const res = await shellRoomsAPI.updCountCeiling(body);
    // return res?.data;
  } catch (e) {}
};

export const shellRoomsColumns = [
  {
    name: "room_type_id",
    label: "ID",
    field: "room_type_id",
    align: "center",
  },
  {
    name: "room_type_name",
    label: "Название",
    field: "room_type_name",
    align: "center",
  },
  {
    name: "room_purpose_name",
    label: "Тип помещения",
    field: "room_purpose_name",
    align: "center",
  },
  // {
  //   name: "is_count_ceiling",
  //   label: "Считать потолок",
  //   field: "is_count_ceiling",
  //   align: "center",
  // },
  // {
  //   name: "video_url",
  //   label: "Кв/МОП",
  //   field: "video_url",
  //   align: "center",
  // },
];
